module.exports = __webpack_public_path__ + "filetype-excel.svg?7f14bb74f1c7d451cf559abb72740f26";